import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'bottom-sheet-controls',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './bottom-sheet-controls.component.html',
  styleUrl: './bottom-sheet-controls.component.scss',
})
export class BottomSheetControlsComponent {
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() onSubmit: EventEmitter<void> = new EventEmitter<void>();

  @Input() cancelText: string | null = 'Cancel';
  @Input() submitText: string = 'Submit';
  @Input() isSubmitting: boolean = false;
}
